import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { concepto } from '../../../../constants/FieldsConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allConceptosAction } from '../../conceptos/ConceptosAction';

const TablaConceptosRecibosComponent = ({ setSelectIdsConceptos }) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const conceptosStore = Redux.useSelector((state) => state.conceptos);

  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      if (conceptosStore.all && conceptosStore.all.length === 0) {
        await allConceptosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setSelectIdsConceptos(rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  function handlerRows(id) {
    const exist = rows.some((e) => e === id);
    if (exist) {
      const l = rows.filter((e) => e !== id);
      setRows(l);
    } else {
      setRows((old) => [...old, id]);
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <FormControl fullWidth size="small" required>
          <InputLabel id={`label_${concepto.name}`}>
            {concepto.label}
          </InputLabel>
          <Select
            id={concepto.name}
            labelId={`label_${concepto.name}`}
            label={concepto.label}
            onChange={(e) => handlerRows(e.target.value)}
          >
            {conceptosStore.all.map((el, index) => {
              return (
                <MenuItem key={`concepto-${index}`} value={el.id}>
                  {el.nombre} - $ {el.costo}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={12} sx={{ mt: 1 }}>
        {rows.map((el, index) => {
          const data = conceptosStore.all.find((it) => it.id === el);
          return (
            <Box key={index} sx={{ width: '100%', mb: 1 }}>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    {data.nombre ?? ''}
                  </Typography>
                </Grid>
                <Grid item md={3}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    $ {data.costo}
                  </Typography>
                </Grid>
                <Grid item md={2} align="end">
                  <BotonComponent
                    icon
                    closeIcon
                    click={() => handlerRows(el)}
                    red
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default TablaConceptosRecibosComponent;
